<template>
  <div>
    <v-container>
      <v-row>
        <h1>Clearances</h1>
      </v-row>
      <v-row v-if="isLoading">
        <v-col>
          <v-card shaped>
            <v-skeleton-loader type="table"></v-skeleton-loader>
          </v-card>
        </v-col>
      </v-row>
      <v-row v-else>
        <v-col cols="12" class="pb-0">
          <v-row class="d-flex justify-center">
            <v-col class="d-flex justify-end">
              <TestForm 
                method="create" 
                methodTitle="Create Clearance" 
                icon="mdi-plus"
                color="primary"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-tabs v-model="tab">
                <v-tab>All Clearances</v-tab>
                <v-tab>Permananent Clearances</v-tab>
                <v-tab>Temporary Clearances</v-tab>
              </v-tabs>
              <v-tabs-items class="pt-5" v-model="tab">
                <v-tab-item>
                  <v-card shaped>
                    <AllClearancesTable />
                  </v-card>
                </v-tab-item>
                <v-tab-item>
                  <v-card shaped>
                    <PermClearanceTable />
                  </v-card>
                </v-tab-item>
                <v-tab-item>
                  <v-card shaped>
                    <TempClearanceTable />
                  </v-card>
                </v-tab-item>
              </v-tabs-items>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
  import AllClearancesTable from '@/components/test/AllClearancesTable'
  import PermClearanceTable from '@/components/test/PermanentClearanceTable'
  import TestForm from '@/components/test/Form'
  import TempClearanceTable from '@/components/test/TempClearanceTable'

  export default {
    name: 'Tests',
    components: { 
      AllClearancesTable,
      PermClearanceTable,
      TestForm,
      TempClearanceTable
    },
    data () {
      return {
        tab: '',
        isLoading: true
      }
    },
    async created () {
      await this.$store.dispatch('getRecords', {
        table: 'Employees',
        view: 'All Employees',
        dispatch: 'setEmployees'
      })
      await this.$store.dispatch('getRecords', {
        table: 'Tests',
        view: 'All Tests',
        dispatch: 'setTests'
      })
      await this.$store.dispatch('getRecords', {
        table: 'Clearances',
        view: 'All Clearances',
        dispatch: 'setClearances'
      })
      this.isLoading = false
    },
  }
</script>
